@if (!showFullTopSubSectionNav) {
  <div class="media-top-menu d-flex flex-column flex-md-row align-items-center" [style.gap]="'0.5rem'">
    <div class="action-info d-flex align-items-center">
      @if (assetInfoVisible) {
        <i class="mtm-icon mtm-icon-topic-info me-2 pointer" (click)="toggleAssetInfo()"></i>
      }
      <i class="mtm-icon mtm-icon-topic-download me-2 pointer" (click)="downloadAsset()"></i>
      @if (assetListVisible) {
        <i class="mtm-icon mtm-icon-topic-list me-2 pointer" (click)="toggleAssetList()"></i>
      }
      <label
        class="m-0 d-none d-md-block file-name md-file-name"
        [title]="subSectionState?.activeFile?.displayName | fileDisplayName"
        >{{ subSectionState?.activeFile?.displayName | fileDisplayName }}</label
      >
    </div>
    @if (versionListVisible) {
      <div
        class="version-dropdown d-none d-md-block"
        ngbDropdown
        container="body"
        dropdownClass="media-player-version-dropdown">
        <button
          ngbDropdownToggle
          [disabled]="isBusy || shouldDisableInteractiveElements"
          (click)="$event.stopPropagation()"
          class="btn d-flex align-item-center justify-content-between p-2 dropdown-toggle">
          <span class="version me-1">{{ `V${subSectionState?.activeVersion?.versionNumber}` }}</span>
          <span>
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </span>
        </button>
        <div ngbDropdownMenu class="p-1 dropdown-menu">
          @for (version of subSectionState?.activeOption?.simpleVersions; track version.versionNumber) {
            <button
              class="d-flex align-items-center btn dropdown-item version-selector-dropdown"
              [disabled]="isBusy"
              (click)="switchVersion(version.versionNumber)">
              <span class="version">{{ `V${version.versionNumber}` }}</span>
            </button>
          }
          @if (hasEditPermission) {
            <button
              class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-manage-versions"
              [disabled]="isBusy"
              (click)="showManageVersions()">
              <span class="text-uppercase">{{ 'versioning_edit_manageVersions' | translate }}</span>
            </button>
          }
          @if (hasEditPermission) {
            <button
              class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-add-version"
              [disabled]="isBusy"
              (click)="createNewVersion()">
              <span class="d-flex align-items-center justify-content-center icon-wrapper me-2">
                <i class="fa fa-plus" aria-hidden="true"></i
              ></span>
              <span class="text-uppercase">{{ 'versioning_edit_createNewVersion' | translate }}</span>
            </button>
          }
        </div>
      </div>
    }
    <div class="d-flex d-md-none w-100">
      <div class="me-auto d-flex align-items-center p-2">
        <label class="m-0 file-name" [title]="subSectionState?.activeFile?.displayName | fileDisplayName">{{
          subSectionState?.activeFile?.displayName | fileDisplayName
        }}</label>
      </div>
      @if (versionListVisible) {
        <div
          class="version-dropdown ms-auto"
          ngbDropdown
          container="body"
          dropdownClass="media-player-version-dropdown">
          <button
            ngbDropdownToggle
            [disabled]="isBusy || shouldDisableInteractiveElements"
            (click)="$event.stopPropagation()"
            class="btn d-flex align-item-center justify-content-between dropdown-toggle">
            <span class="version me-2">{{ `V${subSectionState?.activeVersion?.versionNumber}` }}</span>
            <span class="d-flex align-items-center justify-content-center">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </span>
          </button>
          <div ngbDropdownMenu class="p-1 dropdown-menu">
            @for (version of subSectionState?.activeOption?.simpleVersions; track version.versionNumber) {
              <button
                class="d-flex align-items-center btn dropdown-item version-selector-dropdown"
                [disabled]="isBusy"
                (click)="switchVersion(version.versionNumber)">
                <span class="version">{{ `V${version.versionNumber}` }}</span>
              </button>
            }
            @if (hasEditPermission) {
              <button
                class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-manage-versions"
                [disabled]="isBusy"
                (click)="showManageVersions()">
                <span class="text-uppercase">{{ 'versioning_edit_manageVersions' | translate }}</span>
              </button>
            }
            @if (hasEditPermission) {
              <button
                class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-add-version"
                [disabled]="isBusy"
                (click)="createNewVersion()">
                <span class="d-flex align-items-center justify-content-center icon-wrapper me-2">
                  <i class="fa fa-plus" aria-hidden="true"></i
                ></span>
                <span class="text-uppercase">{{ 'versioning_edit_createNewVersion' | translate }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
@if (showFullTopSubSectionNav && (isFullscreen || isNewShareLink)) {
  <div class="media-top-menu d-flex flex-column flex-md-row align-items-center" [style.gap]="'0.5rem'">
    <div class="d-flex align-items-center item-info-container">
      <div class="d-flex align-items-center w-100">
        <button class="btn btn-home" [disabled]="isKpfPreview" (click)="goToHome()">
          <!-- A.MAK: we can change with this icon <i class="fa-light fa-house"></i> -->
          <img src="assets/svg/subsection/home-icon.svg" width="18" height="18" alt="Home" loading="lazy" />
        </button>
        <div class="d-flex align-item-center w-100">
          <div class="action-info d-flex align-items-center">
            <!-- Navigation buttons moved to child-layout header - shown here in fullscreen mode or share link -->
            @if ((isFullscreen || isNewShareLink) && showNavigationButtons) {
              <button
                class="btn navigation-button back-button pointer me-2 d-flex align-items-center justify-content-center _500"
                [disabled]="!treeState?.root?.children.length"
                (click)="$event.stopPropagation(); navigateToPrevious()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </button>
              <button
                class="btn navigation-button next-button pointer me-2 d-flex align-items-center justify-content-center _500"
                [disabled]="!treeState?.root?.children.length"
                (click)="$event.stopPropagation(); navigateToNext()">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
            }
            @if (isFullscreen || isNewShareLink) {
              <div class="mtm-breadcrumb-project-container d-flex align-items-center">
                @if (!!projectService?.project?.id) {
                  <mtm-item-icon
                    class="me-1"
                    [containerWidth]="'24px'"
                    [generatedTextColor]="true"
                    [height]="'24px'"
                    [imageUrl]="projectAvatarUrl"
                    [name]="projectName"
                    [width]="'24px'"
                    [cacheBuster]="cacheBuster">
                  </mtm-item-icon>
                }
                <mtm-breadcrumb-project
                  (selectNode)="navigateToNode($event)"
                  [isDashboard]="isDashboard"
                  [isWidgetCollapsed]="isWidgetCollapsed"></mtm-breadcrumb-project>
              </div>
            }
          </div>
        </div>
      </div>
      @if (versionListVisible && treeState?.selectedNode?.type === treeNodeType.File) {
        <div class="d-flex align-item-center ms-auto ms-md-0">
          <div
            class="version-dropdown d-block"
            ngbDropdown
            container="body"
            dropdownClass="media-player-version-dropdown">
            <button
              ngbDropdownToggle
              [disabled]="isBusy || shouldDisableInteractiveElements"
              (click)="$event.stopPropagation()"
              class="btn d-flex align-item-center justify-content-between dropdown-toggle">
              <span class="version me-2">{{ `V${subSectionState?.activeVersion?.versionNumber}` }}</span>
              <span class="d-flex align-items-center justify-content-center">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
            </button>
            <div ngbDropdownMenu class="p-1 dropdown-menu">
              @for (version of subSectionState?.activeOption?.simpleVersions; track version.versionNumber) {
                <button
                  class="d-flex align-items-center btn dropdown-item version-selector-dropdown"
                  [disabled]="isBusy"
                  (click)="switchVersion(version.versionNumber)">
                  <span class="version">{{ `V${version.versionNumber}` }}</span>
                </button>
              }
              @if (hasEditPermission) {
                <button
                  class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-manage-versions"
                  [disabled]="isBusy"
                  (click)="showManageVersions()">
                  <span class="text-uppercase">{{ 'versioning_edit_manageVersions' | translate }}</span>
                </button>
              }
              @if (hasEditPermission) {
                <button
                  class="d-flex align-items-center justify-content-center btn dropdown-item version-selector-dropdown btn-add-version"
                  [disabled]="isBusy"
                  (click)="createNewVersion()">
                  <span class="d-flex align-items-center justify-content-center icon-wrapper me-2">
                    <i class="fa fa-plus" aria-hidden="true"></i
                  ></span>
                  <span class="text-uppercase">{{ 'versioning_edit_createNewVersion' | translate }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      }
    </div>
    <div class="d-flex align-items-center w-100" [style.gap]="'0.25rem'">
      @if (treeState?.selectedNode?.type === treeNodeType.File) {
        <div class="d-flex align-items-center m-1" [style.gap]="'0.5rem'">
          <i class="mtm-icon mtm-icon-topic-info pointer" (click)="toggleAssetInfo()"></i>
          <i class="mtm-icon mtm-icon-topic-download pointer" (click)="downloadAsset()"></i>
          @if (assetListVisible) {
            <i class="mtm-icon mtm-icon-topic-list pointer" (click)="toggleAssetList()"></i>
          }
        </div>
      }
      @if (
        !subSectionPreview?.subSectionState?.reviewLink &&
        subSectionPreview?.versionData != null &&
        subSectionPreview?.canVote &&
        votingVisible &&
        treeState?.selectedNode?.type === treeNodeType.File &&
        !isShareLinkPreview &&
        !isReleasePreview &&
        !shouldDisableInteractiveElements
      ) {
        <div class="d-flex align-item-center w-100 justify-content-md-end mx-1 me-md-auto me-md-1">
          <div class="d-flex align-items-center vote-container justify-content-md-end">
            <button
              class="d-flex align-items-center flex-grow-1 btn btn-accept"
              [disabled]="subSectionPreview?.isLoading"
              (click)="subSectionPreview?.vote(true)">
              <span
                class="flex-grow-1 icon-wrapper me-1"
                [ngbTooltip]="subSectionPreview?.totalApproved > 0 ? proponentsTooltip : null"
                tooltipClass="voters-tooltip">
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.8688 16.1202C5.8688 16.3004 5.79721 16.4732 5.66979 16.6006C5.54236 16.7281 5.36954 16.7997 5.18933 16.7997H0.679469C0.499263 16.7997 0.326436 16.7281 0.199011 16.6006C0.0715866 16.4732 0 16.3004 0 16.1202V7.12659C0 6.94638 0.0715866 6.77356 0.199011 6.64613C0.326436 6.51871 0.499263 6.44712 0.679469 6.44712H5.18933C5.36954 6.44712 5.54236 6.51871 5.66979 6.64613C5.79721 6.77356 5.8688 6.94638 5.8688 7.12659V16.1202ZM17.4197 12.917C17.4202 13.0865 17.3873 13.2545 17.3228 13.4113C17.2583 13.5681 17.1635 13.7107 17.0439 13.8308C16.9243 13.951 16.7822 14.0463 16.6256 14.1115C16.4691 14.1767 16.3013 14.2103 16.1317 14.2106H15.5437C15.886 14.2121 16.2137 14.3493 16.4548 14.5922C16.696 14.8351 16.8309 15.1638 16.8299 15.5061C16.8304 15.6754 16.7975 15.8433 16.7331 15.9999C16.6687 16.1566 16.5741 16.2991 16.4547 16.4192C16.3353 16.5393 16.1934 16.6348 16.0371 16.7C15.8808 16.7653 15.7131 16.7992 15.5437 16.7997H10.5523C9.44533 16.7997 7.5656 16.1706 6.8432 15.9167C6.75942 15.8867 6.68698 15.8314 6.63585 15.7586C6.58471 15.6857 6.55738 15.5988 6.5576 15.5098V7.43459C6.5576 6.24925 10.4776 5.12179 9.8672 1.68152C9.74027 0.977787 10.0296 0.274055 10.7072 0.0593879C10.8687 0.00852063 11.0387 -0.00994444 11.2074 0.0050535C11.3761 0.0200514 11.5402 0.0682163 11.6902 0.146784C11.8402 0.225352 11.9732 0.332775 12.0816 0.462888C12.19 0.593001 12.2717 0.743243 12.3219 0.904988C13.0125 3.11885 12.5085 4.94072 11.9112 6.44712H15.8312C16.0007 6.44736 16.1686 6.48103 16.3251 6.5462C16.4816 6.61136 16.6238 6.70675 16.7434 6.82689C16.863 6.94704 16.9578 7.08959 17.0223 7.24639C17.0868 7.4032 17.1197 7.57118 17.1192 7.74072C17.1197 7.91026 17.0868 8.07824 17.0223 8.23505C16.9578 8.39185 16.863 8.5344 16.7434 8.65455C16.6238 8.7747 16.4816 8.87008 16.3251 8.93524C16.1686 9.00041 16.0007 9.03407 15.8312 9.03432H16.4229C16.5925 9.03481 16.7603 9.06872 16.9167 9.13411C17.0731 9.1995 17.2151 9.29509 17.3346 9.41541C17.454 9.53573 17.5486 9.67842 17.6129 9.83532C17.6771 9.99222 17.7098 10.1602 17.7091 10.3298C17.7096 10.4993 17.6766 10.6673 17.6121 10.8241C17.5476 10.9809 17.4529 11.1235 17.3333 11.2436C17.2136 11.3638 17.0715 11.4591 16.915 11.5243C16.7584 11.5895 16.5906 11.6231 16.4211 11.6234H16.1355C16.4772 11.6249 16.8045 11.7619 17.0452 12.0045C17.286 12.247 17.4207 12.5752 17.4197 12.917Z"
                    fill="#43CB9A" />
                </svg>
              </span>
              <asset-voters class="d-none d-lg-block" [voters]="subSectionPreview?.currentProponents"></asset-voters>
              <ng-template #proponentsTooltip>
                <asset-voters [voters]="subSectionPreview?.currentProponents" [viewMode]="'tooltip'"></asset-voters>
              </ng-template>
            </button>
            <button
              class="d-flex align-item-center flex-grow-1 btn btn-reject"
              [disabled]="subSectionPreview?.isLoading"
              (click)="subSectionPreview?.vote(false)">
              <span
                class="flex-grow-1 icon-wrapper me-1"
                [ngbTooltip]="subSectionPreview?.totalRejected > 0 ? opponentsTooltip : null"
                tooltipClass="voters-tooltip">
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.8773 0.879814C11.8773 0.699607 11.9489 0.526782 12.0763 0.399358C12.2037 0.271934 12.3766 0.200346 12.5568 0.200346L17.0666 0.200346C17.2468 0.200346 17.4197 0.271934 17.5471 0.399359C17.6745 0.526783 17.7461 0.699608 17.7461 0.879814L17.7461 9.87341C17.7461 10.0536 17.6745 10.2264 17.5471 10.3539C17.4197 10.4813 17.2468 10.5529 17.0666 10.5529L12.5568 10.5529C12.3766 10.5529 12.2037 10.4813 12.0763 10.3539C11.9489 10.2264 11.8773 10.0536 11.8773 9.87341L11.8773 0.879814ZM0.32636 4.08301C0.32587 3.91347 0.358806 3.74549 0.423291 3.58869C0.487777 3.43188 0.582546 3.28933 0.702173 3.16918C0.8218 3.04904 0.963939 2.95365 1.12046 2.88849C1.27698 2.82332 1.44481 2.78966 1.61436 2.78941L2.20236 2.78941C1.8601 2.78793 1.53241 2.65067 1.29126 2.40777C1.05012 2.16488 0.915235 1.83621 0.916227 1.49394C0.915737 1.32455 0.948614 1.15673 1.01298 1.00005C1.07735 0.843369 1.17195 0.7009 1.29138 0.580777C1.41081 0.460654 1.55272 0.365231 1.70903 0.299956C1.86534 0.234681 2.03298 0.200835 2.20236 0.200345L7.19383 0.200345C8.30076 0.200345 10.1805 0.829414 10.9029 1.08328C10.9867 1.11334 11.0591 1.16858 11.1102 1.24144C11.1614 1.3143 11.1887 1.4012 11.1885 1.49021L11.1885 9.56541C11.1885 10.7507 7.26849 11.8782 7.87889 15.3185C8.00583 16.0222 7.71649 16.7259 7.03889 16.9406C6.87736 16.9915 6.70738 17.0099 6.53869 16.9949C6.37 16.9799 6.20594 16.9318 6.05591 16.8532C5.90589 16.7746 5.77285 16.6672 5.66445 16.5371C5.55605 16.407 5.47441 16.2568 5.42422 16.095C4.73356 13.8811 5.23756 12.0593 5.83489 10.5529L1.9149 10.5529C1.74535 10.5526 1.57751 10.519 1.42099 10.4538C1.26447 10.3886 1.12233 10.2933 1.00271 10.1731C0.883078 10.053 0.788314 9.91041 0.723828 9.7536C0.659342 9.5968 0.626406 9.42882 0.626897 9.25928C0.626406 9.08973 0.659343 8.92176 0.723828 8.76495C0.788314 8.60815 0.883078 8.4656 1.00271 8.34545C1.12233 8.2253 1.26447 8.12992 1.42099 8.06475C1.57751 7.99959 1.74535 7.96592 1.9149 7.96568L1.32316 7.96568C1.15361 7.96519 0.985829 7.93128 0.8294 7.86589C0.672971 7.8005 0.530972 7.70491 0.411519 7.58459C0.292066 7.46427 0.197503 7.32158 0.133244 7.16468C0.0689859 7.00778 0.0362939 6.83976 0.0370302 6.67021C0.03654 6.50067 0.0694761 6.33269 0.133962 6.17589C0.198447 6.01908 0.293212 5.87653 0.412839 5.75639C0.532466 5.63624 0.674602 5.54085 0.831124 5.47569C0.987647 5.41053 1.15548 5.37686 1.32503 5.37661L1.61063 5.37661C1.26886 5.37513 0.941642 5.23807 0.700849 4.99552C0.460055 4.75298 0.325368 4.42478 0.32636 4.08301Z"
                    fill="#FE666D" />
                </svg>
              </span>
              <asset-voters class="d-none d-lg-block" [voters]="subSectionPreview?.currentOpponents"></asset-voters>
              <ng-template #opponentsTooltip>
                <asset-voters [voters]="subSectionPreview?.currentOpponents" [viewMode]="'tooltip'"></asset-voters>
              </ng-template>
            </button>
          </div>
        </div>
      }
      <div class="d-flex align-items-center ms-auto">
        @if (
          !subSectionPreview?.subSectionState?.reviewLink &&
          !subSectionPreview?.isSubsectionFile &&
          compareVisible &&
          treeState?.selectedNode?.type === treeNodeType.File &&
          subSectionPreview?.versionData &&
          !isShareLinkPreview &&
          !isReleasePreview &&
          !shouldDisableInteractiveElements
        ) {
          <div class="d-flex align-items-center buttons me-2">
            <button
              class="d-flex align-items-center justify-content-center flex-grow-1 btn btn-compare py-2 px-1"
              title="Compare"
              (click)="subSectionPreview?.showComparison()">
              <span class="icon-wrapper">
                <!-- A.MAK: we can change with this fontAwesome icons -->
                <img
                  src="assets/svg/subsection/compare-panels.svg"
                  width="18"
                  height="18"
                  alt="Compare Panels"
                  loading="lazy" />
              </span>
            </button>
          </div>
        }
        @if (!subSectionState?.reviewLink && !isNewShareLink) {
          <div class="me-2">
            <mtm-user-list-dropdown [project]="projectService?.project"></mtm-user-list-dropdown>
          </div>
        }
        @if (showListViewToggleButton) {
          <div class="d-flex align-items-center buttons me-2">
            <button
              class="d-flex align-items-center justify-content-center flex-grow-1 btn btn-list-view py-2 px-1"
              title="Toggle ListView"
              (click)="toggleListView()"
              [class.active]="isListViewMode"
              [class.inactive]="!isListViewMode">
              <span class="icon-wrapper">
                <!-- A.MAK: we can change with this fontAwesome icons -->
                <img
                  src="assets/svg/subsection/toggle-list-view-icon.svg"
                  width="18"
                  height="18"
                  alt="Toggle ListView"
                  loading="lazy" />
              </span>
            </button>
          </div>
        }
        <top-nav-treeview-btn></top-nav-treeview-btn>
        @if ((isPlatformTaskShowing || isMediaPreviewTasksChatShowing) && hasCommentPanelWidth) {
          <div class="d-flex align-items-center buttons me-1">
            <button
              class="d-flex align-items-center justify-content-center flex-grow-1 btn btn-chat py-2 px-1"
              title="Task"
              (click)="openTask()"
              [disabled]="false"
              [attr.aria-disabled]="false"
              [class.active]="isCommentExpanded && rightViewMode === 'task'"
              [class.inactive]="!isCommentExpanded">
              <span class="icon-wrapper">
                <mtm-task-icon
                  width="18"
                  height="18"
                  class="clickable"
                  [active]="isCommentExpanded && rightViewMode === 'task'"></mtm-task-icon>
              </span>
            </button>
          </div>
        }
        @if (
          ((canShowCommentIcon || isMediaPreviewCommentsChatShowing) && isFullscreen) ||
          ((canShowCommentIcon || isMediaPreviewCommentsChatShowing) && (isShareLinkPreview || isNewShareLink))
        ) {
          <div class="d-flex align-items-center buttons me-2">
            <button
              class="d-flex align-items-center justify-content-center flex-grow-1 btn btn-chat py-2 px-1"
              title="Comment"
              (click)="openChat()"
              [class.active]="isCommentExpanded"
              [class.inactive]="!isCommentExpanded">
              <span class="icon-wrapper">
                <mtm-chat-sparkle-icon width="18" height="18" class="clickable"></mtm-chat-sparkle-icon>
              </span>
            </button>
          </div>
        }
        @if (showFullscreenButton) {
          <div class="d-flex align-items-center buttons me-2">
            <button
              class="d-flex align-items-center justify-content-center flex-grow-1 btn btn-fullscreen btn-compare py-2 px-1"
              title="Fullscreen"
              (click)="toggleFullscreen()"
              [class.active]="isFullscreen"
              [disabled]="subSectionPreview?.isLoading">
              @if (!isFullscreen) {
                <span class="icon-wrapper">
                  <!-- A.MAK: we can change with this fontAwesome icons -->
                  <img
                    src="assets/svg/subsection/fullscreen-icon.svg "
                    width="18"
                    height="18"
                    alt="Fullscreen"
                    loading="lazy" />
                </span>
              } @else {
                <span class="icon-wrapper">
                  <!-- A.MAK: we can change with this fontAwesome icons -->
                  <img
                    src="assets/svg/subsection/exit-fullscreen.svg"
                    width="18"
                    height="18"
                    alt="Exit Fullscreen"
                    loading="lazy" />
                </span>
              }
            </button>
          </div>
        }
      </div>
      @if (treeState?.selectedNode?.type === treeNodeType.File && shouldShowEditAssetButton) {
        <div class="d-flex align-items-center me-1">
          <button
            class="btn c-mtm-brand mtm-button mtm-border-orange-button _700 t-uppercase p-0 text-nowrap text-align-center d-flex flex-column"
            (click)="navigateToPreviewPage()"
            [style.min-width]="'100px'"
            [style.max-width]="'100%'">
            <span class="d-inline-block text-truncate">{{ 'editMode' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </div>
}
